import cookie from 'js-cookie'
import { request, isProd } from '@finance/ajax-clientkey'


let userApi = 'https://userapi.feidee.net'

if (!isProd && window.location.port) {
  userApi = ''
} else if (!isProd) {
  userApi = 'https://userapi.feidee.cn'
}

export const UserApi = userApi

export const setCookieValue = async(key, val, p = { timeout: 0, hostname: '' }) => {
  const defaultHostname = window.location.hostname.split('.')
  const options = {
    domain: p.hostname || `${defaultHostname[1]}.${defaultHostname[2]}`
  }
  if (p.timeout && typeof p.timeout === 'number') {
    options.expires = p.timeout / 864e+2
  }
  cookie.set(key, val, options)
}

// 删除
export const clearCookieValue = async(key, p = { hostname: '' }) => {
  const defaultHostname = window.location.hostname.split('.')
  const options = {
    domain: p.hostname || `${defaultHostname[1]}.${defaultHostname[2]}`,
    path: p.path || '/'
  }
  cookie.remove(key, options)
}

// 设置多个cookie
export const setCookies = async(cookieConfig) => {
  Object.keys(cookieConfig).forEach((item) => {
    if (cookieConfig[item].data) {
      setCookieValue(`${item}`, cookieConfig[item].data, { timeout: cookieConfig[item].expires })
    }
  })
}

// 清除多个cookie
export const clearCookies = async(cookieArr = [], p = {}) => {
  cookieArr.forEach((item) => {
    if (item) {
      clearCookieValue(item, p)
    }
  })
}

/**
 * 获取加密的uid与suid
 * @param {*} params
 * @returns
 * @doc http://yapi.sui.work/project/591/interface/api/177975
 */
 export const getUserIds = (params = {}, options = {}) => {
  const { tokenType = 'Bearer', token = ''} = params;
  if(!token) return Promise.reject()
  return request({
    url: `${userApi}/v1/profile/upload_id`,
    header: {
      Authorization: `${tokenType} ${token}`
    },
    showLoading: false,
    showError: false,
    ...options
  })
}

export const setLoginCookie = async(params) => {
  const expiresTime = params.expires || (60 * 60 * 24 * 30) // 30天
  const loginState = params.loginState || false
  setCookies({
    isLogin: {
      data: loginState + '',
      expires: expiresTime
    },
    ssj_token: {
      data: params.token || '',
      expires: expiresTime
    },
    ssj_token_type: {
      data: params.tokenType || 'Bearer',
      expires: expiresTime
    }
  })
}

export const setUserIdCookie = async(params) => {
  const expiresTime = params.expires || (60 * 60 * 24 * 30) // 30天
  setCookies({
    ssj_id: {
      data: params.ssjid || '',
      expires: expiresTime
    },
    ssj_uid: {
      data: params.suid || '',
      expires: expiresTime
    }
  })
}

export const getSuidAndSetCookie = async(params = { tokenType: 'Bearer', token: '' }) => {
  getUserIds(params)
    .then((result) => {
      if (params.token && result) {
        setLoginCookie({
          loginState: true,
          ...params
        })
        setUserIdCookie(result)
      } else {
        cookie.set('isLogin', false)
      }
    })
    .catch((err) => {
      console.error('登录失败getUserIds：', err)
      cookie.set('isLogin', false)
    })
}

// 兼容旧版 后面将删除 推荐使用getSuidAndSetCookie
export const setLoginLookies = getSuidAndSetCookie